<script setup lang="ts">
   const partners = [
      { name: 'US Polo Assn', image: '/img/us-polo-assn.webp', url: 'https://www.uspashop.com/' },
      { name: 'Red Barn Feed & Supply', image: '/img/red-barn.webp', url: 'https://redbarn1.com/' },
      { name: 'Double D Ranch', image: '/img/double-d-ranch.webp', url: 'https://doubledranch.com/' },
      { name: 'VQ Jewellery', image: '/img/vq-jewellery.webp', url: 'https://vqjewellery.com/' },
      { name: 'Tackeria', image: '/img/the-tackeria.webp', url: 'https://tackeria.com/' },
      { name: 'Aqua-Tec Equine', image: '/img/aquatec.webp', url: 'https://aquatecequine.com/' },
      { name: 'Eastern Hay', image: '/img/eastern-hay.webp', url: 'https://easternhay.com/' },
      { name: "Tato's Mallets", image: '/img/tatos.webp', url: 'https://www.tatosmallets.com/' },
      { name: 'The Wheelbarrow Sombrero', image: '/img/wheel-barrow-sombrero.webp', url: 'https://www.thewheelbarrowsombrero.com/' },
      { name: 'USPA', image: '/img/united-states-polo-association.webp', url: 'https://www.uspolo.org/' },
   ];
</script>

<template>
   <div>
      <div class="mx-auto mt-12 grid max-w-7xl grid-cols-2 gap-8 px-6 sm:grid-cols-3 md:grid-cols-4">
         <a
            v-for="partner in partners"
            :key="partner.name"
            :href="partner.url"
            target="_blank"
            rel="noopener"
            class="flex items-center justify-center rounded-lg p-4 transition-shadow hover:shadow-md">
            <img
               :src="partner.image"
               :alt="partner.name"
               class="max-h-36 max-w-full object-contain" />
         </a>
      </div>
      <p class="mt-10 text-center text-sm font-semibold text-gray-500">
         WOW Polo Series LLC is a 501(c)3
      </p>
   </div>
</template>
